/**
 * テナントが扱える排出事業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/disposal_methods`

const search_disposal_method = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_disposal_method
